"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = __importDefault(require("./styles"));
var Row = function (_a) {
    var item = _a.item, columns = _a.columns, isHidden = _a.isHidden, className = _a.className, style = _a.style;
    if (isHidden)
        return null;
    var cells = columns.map(function (x, i) {
        if (x.isHidden)
            return null;
        return (react_1.default.createElement("div", { key: i, className: "cell", style: x.style, title: typeof item[x.key] === 'string' ? item[x.key] : null, onClick: item.onClick }, item[x.key]));
    });
    return react_1.default.createElement(styles_1.default, { className: className || '', style: style }, cells);
};
exports.default = Row;
//# sourceMappingURL=index.js.map